import { Range } from 'types';

export const removeRangeFromRanges = (
  range: Range,
  ranges: Range[]
): Range[] => {
  const result: Range[] = [];
  ranges.forEach((currentRange: Range) => {
    if (currentRange.from < range.from && currentRange.to > range.to) {
      result.push(
        { ...range, from: currentRange.from, to: range.from - 1 },
        { ...range, from: range.to + 1, to: currentRange.to }
      );
    } else if (currentRange.from === range.from && currentRange.to > range.to) {
      result.push({ ...range, from: range.to + 1, to: currentRange.to });
    } else if (currentRange.from < range.from && currentRange.to === range.to) {
      result.push({ ...range, from: currentRange.from, to: range.from - 1 });
    } else if (
      currentRange.from !== range.from &&
      currentRange.to !== range.to
    ) {
      result.push(currentRange);
    }
  });
  return result;
};
